import cookieImportUntyped from 'js-cookie/dist/js.cookie.mjs';

interface CookieStatic {
    get(name: string): string | undefined;
    set(name: string, value: string, options?: Record<string, unknown>): void;
    remove(name: string, options?: Record<string, unknown>): void;
}

/** Unwrap ESM default interop so get/set/remove work under legacy namespace imports. */
const Cookie: CookieStatic = ((cookieImportUntyped as CookieStatic & {default?: CookieStatic}).default ??
    cookieImportUntyped) as CookieStatic;

export {Cookie};
export default Cookie;

export type CookieAttributes = Record<string, unknown>;
